var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"smart-light-grey"},[_c('Toast'),_vm._v(" "),_c('nuxt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }